import {
  CANCEL_SUBSCRIPTION, CANCEL_SUBSCRIPTION_FAILED, CANCEL_SUBSCRIPTION_SUCCESSFULLY, ERROR_ON_GETTING_INVOICE_LIST,
  ERROR_ON_GETTING_SUBSCRIPTION_LIST, INTERVAL_CHOSEN, RECEIVED_INVOICE_LIST, RECEIVED_SUBSCRIPTION_LIST,
  START_FETCHING_INVOICE_LIST,
  START_FETCHING_SUBSCRIPTION_LIST, TIER_CHOSEN,
  START_FETCHING_EMAIL_SUBSCRIBE_STATUS,
  RECEIVED_EMAIL_SUBSCRIBE_STATUS,
  START_TOGGLE_PRINT_STATUS_EMAIL,
  TOGGLE_PRINT_STATUS_EMAIL_SUCCESSFULLY,
  TOGGLE_PRINT_STATUS_EMAIL_FAILED
} from "./types";
import axios from 'axios';
import {backendDomain} from "../modules/configs";
import { EMAIL_SUBSCRIBE_STATUS } from "../containers/account-setting-container";

export const startFetchingSubscriptionList = () => dispatch => {
  dispatch({ type: START_FETCHING_SUBSCRIPTION_LIST });
  return axios.get(`${backendDomain}/subscription/status`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } })
    .then(res => {
      dispatch(receivedSubscriptionList(res.data));
    })
    .catch(error => dispatch(errorOnGettingSubscriptionList(error)))
}

const receivedSubscriptionList = (subscriptionList) => ({
  type: RECEIVED_SUBSCRIPTION_LIST,
  payload: { subscriptionList }
})

const errorOnGettingSubscriptionList = (error) => ({
  type: ERROR_ON_GETTING_SUBSCRIPTION_LIST,
  payload: { error }
})

export const chooseInterval = (chosenInterval) => ({
  type: INTERVAL_CHOSEN,
  payload: { chosenInterval }
})

export const chooseTier = (chosenTierRank) => ({
  type: TIER_CHOSEN,
  payload: { chosenTierRank }
})

export const cancelSubscription = (subscriptionId) => dispatch => {
  dispatch({ type: CANCEL_SUBSCRIPTION });
  return axios.post(`${backendDomain}/subscription/cancel`,
    { subscriptionId }, { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } })
    .then(res => {
      dispatch({ type: CANCEL_SUBSCRIPTION_SUCCESSFULLY })
      dispatch(startFetchingSubscriptionList());
    })
    .catch(error => dispatch({ type: CANCEL_SUBSCRIPTION_FAILED }))
}

export const startFetchingInvoiceList = () => dispatch => {
  dispatch({ type: START_FETCHING_INVOICE_LIST })
  return axios.get(`${backendDomain}/subscription/listInvoices`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } })
    .then(res => dispatch(receivedInvoiceList(res.data)))
    .catch(err => dispatch(errorOnGettingInvoiceList(err)))
}

const receivedInvoiceList = (invoiceList) => ({
  type: RECEIVED_INVOICE_LIST,
  payload: { invoiceList }
})

const errorOnGettingInvoiceList = (error) => ({
  type: ERROR_ON_GETTING_INVOICE_LIST,
  payload: { error }
})

export const startFetchingEmailSubscriptionStatus = () => dispatch => {
  dispatch({ type: START_FETCHING_EMAIL_SUBSCRIBE_STATUS })
  axios.post(`${backendDomain}/preference/subscribeStatus`, { idToken: localStorage.getItem('id_token') }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
  })
      .then(res => {
        if (res.status === 200) {
          const { currentStatus } = res.data;
          dispatch(receivedEmailSubscribeStatus(currentStatus))
        }
      })
      .catch(err => {
        console.log(err);
      })
};

const receivedEmailSubscribeStatus = (currentStatus) => ({
  type: RECEIVED_EMAIL_SUBSCRIBE_STATUS,
  payload: { emailSubscribeStatus: currentStatus }
});

export const startTogglePrintStatusEmail = (currentStatus) => dispatch => {
  dispatch({ type: START_TOGGLE_PRINT_STATUS_EMAIL });
  const urlSuffix = currentStatus === EMAIL_SUBSCRIBE_STATUS.ON ? 'unsubscribe' : 'subscribe';
  const url = `${backendDomain}/preference/${urlSuffix}`;
  axios.post(url, { idToken: localStorage.getItem('id_token') }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
  })
      .then(res => {
        if (res.status === 201) {
          const newStatus = res.data.currentStatus;
          dispatch(togglePrintStatusEmailSuccess(newStatus));
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(togglePrintStatusEmailFail());
      })
};

const togglePrintStatusEmailSuccess = (emailSubscribeStatus) => ({
  type: TOGGLE_PRINT_STATUS_EMAIL_SUCCESSFULLY,
  payload: { emailSubscribeStatus }
});

const togglePrintStatusEmailFail = () => ({
  type: TOGGLE_PRINT_STATUS_EMAIL_FAILED
});




// WEBPACK FOOTER //
// ./src/actions/getSubscriptions.js